import { createSlice } from "@reduxjs/toolkit";
const _ = require("lodash");

export const initialToastsState = {
  status: undefined,
  title: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const toastsSlice = createSlice({
  name: "toasts",
  initialState: initialToastsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    toastCreated: (state, action) => {
      state.status = action.payload.status;
      state.title = action.payload.title;
    },
    toastHidden: (state, action) => {
      state.status = undefined;
      state.title = undefined;
    },
  },
});
